<div class="toolbar">
  <ng-container *ngFor="let option of options">
    <span
      *ngIf="option.type === optionType.Divider"
      class="toolbar__divider"
    ></span>
    <button
      *ngIf="option.type === optionType.Action"
      type="button"
      class="toolbar-button"
      [matTooltip]="option.tooltipFn ? option.tooltipFn() : ''"
      [class.toolbar-button--active]="
        option.isActiveFn ? option.isActiveFn() : false
      "
      (click)="handleActionClick($event, option)"
    >
      <icon set="lucide" [name]="option.label" size="22" />
    </button>
  </ng-container>
</div>
